export class ContactTagModel implements IContactTagModel {
  tag?: string | undefined;
  dateAdded?: string | undefined;

  constructor(data?: IContactTagModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.tag = Data["tag"];
      this.dateAdded = Data["dateAdded"];
    }
  }

  static fromJS(data: any): ContactTagModel {
    data = typeof data === 'object' ? data : {};
    let result = new ContactTagModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tag"] = this.tag;
    data["dateAdded"] = this.dateAdded;
    return data;
  }
}

export interface IContactTagModel {
  tag?: string | undefined;
  dateAdded?: string | undefined;
}